export const createImageSet = (responsiveImageSet) => {
  const breakpoints = ["lg", "md", "sm", "xs"], imageSet = {}
  let previousImage = null

  if (!responsiveImageSet || !Object.keys(responsiveImageSet).length) {
    return null
  }

  // Kentico Image content items only have one asset, so we’ll set the same
  // asset for each breakpoint so they can be handled the same way as
  // responsive images in templates
  if (responsiveImageSet.system.type === "image_element") {
    const [specifiedImage] = responsiveImageSet.elements.image__asset.value
    breakpoints.forEach(breakpoint => {
      imageSet[breakpoint] = specifiedImage
    })
    return imageSet
  }

  // Determine the largest image content item returned from the Kentico API that has an image populated
  // Images must be passed in from largest to smallest. Empty items are filtered out and the first remaining is returned
  const getLargestImage = contentItems => {
    const imageItemsWithValues = contentItems.filter(imageItem => imageItem.value.length)
    return imageItemsWithValues.length ? imageItemsWithValues[0].value : null
  }
  // Set a default/fallback image that will be used for breakpoints that don’t have an image specified or an image from
  // a previous breakpoint that can be used instead.
  const fallbackImage = getLargestImage([responsiveImageSet.elements.responsive_image__lg, responsiveImageSet.elements.responsive_image__md, responsiveImageSet.elements.responsive_image__sm, responsiveImageSet.elements.responsive_image__xs])

  // Build an object that will have an image for each breakpoint.
  // Prefer a user specified image if available, then the next largest breakpoint, and finally the largest image available)
  breakpoints.forEach(breakpoint => {
    const [specifiedBreakpointImage] =  responsiveImageSet.elements[`responsive_image__${breakpoint}`].value
    imageSet[breakpoint] = specifiedBreakpointImage ? specifiedBreakpointImage : (previousImage ? previousImage : fallbackImage)
    previousImage = imageSet[breakpoint]
  })

  return imageSet
}